var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/RenderableConfig.ts
import { A } from "@adornis/base/env-info.js";
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
var RenderableConfig = class extends AdornisEntity {
  value(key, size = void 0, exactValue = true) {
    if (Array.isArray(key))
      return this._value(size, exactValue, key);
    return this._value(size, exactValue, [key]);
  }
  _value(size, exactValue, keys) {
    if (!size)
      return this.resolvePathToValue(keys);
    const config = this.configs.find(
      (config2) => RenderableConfigItem.stringPath(config2.keyArray) === RenderableConfigItem.stringPath(keys) && config2.size === size
    );
    if (config?.value || exactValue)
      return config?.value ?? null;
    return this.resolvePathToValue(keys);
  }
  setValue(key, value, size) {
    if (Array.isArray(key))
      return this._setValue(key, value, size);
    return this._setValue([key], value, size);
  }
  _setValue(keys, value, size) {
    const resolvedValue = this.resolvePathToValue(keys);
    if (typeof resolvedValue !== typeof value && value !== null && resolvedValue !== null) {
      throw new Error("type mismatch!");
    }
    if (!size) {
      const filteredConfigs = this.configs.filter((config) => {
        if (config.keys !== keys)
          return true;
        if (config.value !== value)
          return true;
        return false;
      });
      this.configs = filteredConfigs;
      let iterationValue = this;
      for (const [index, key] of keys.entries()) {
        if (index === keys.length - 1)
          iterationValue[key] = value;
        else
          iterationValue = iterationValue[key];
      }
      return { resetFieldValue: false };
    }
    return this._setConfigValue(keys, value, size);
  }
  _setConfigValue(keys, value, size) {
    const existingConfigIndex = this.configs.findIndex(
      (config) => RenderableConfigItem.stringPath(config.keyArray) === RenderableConfigItem.stringPath(keys) && config.size === size
    );
    const existingConfig = this.configs[existingConfigIndex];
    if (!value || value === this.resolvePathToValue(keys)) {
      if (existingConfigIndex === -1)
        return { resetFieldValue: true };
      this.configs.splice(existingConfigIndex, 1);
      return { resetFieldValue: true };
    }
    if (existingConfig) {
      return existingConfig.value = value;
    }
    if (typeof value === "string") {
      this.configs.push(
        new RenderableConfigItemString({ keyArray: RenderableConfigItem.toStringArray(keys), value, size })
      );
      return { resetFieldValue: false };
    }
    if (typeof value === "number") {
      this.configs.push(
        new RenderableConfigItemInt({ keyArray: RenderableConfigItem.toStringArray(keys), value, size })
      );
      return { resetFieldValue: false };
    }
    if (typeof value === "boolean") {
      this.configs.push(
        new RenderableConfigItemBoolean({ keyArray: RenderableConfigItem.toStringArray(keys), value, size })
      );
      return { resetFieldValue: false };
    }
    throw new Error(`config not createable for values: ${keys}, ${value}, ${size} `);
  }
  resolvePathToValue(keys) {
    try {
      let value = this;
      for (const key of keys) {
        value = value[key];
      }
      return value;
    } catch {
    }
  }
};
RenderableConfig._class = "RenderableConfig";
__decorateClass([
  validate(nonOptional()),
  Field((type) => [RenderableConfigItem], { default: (v) => v ?? [] })
], RenderableConfig.prototype, "configs", 2);
RenderableConfig = __decorateClass([
  Entity()
], RenderableConfig);
var RenderableConfigItem = class extends AdornisEntity {
  get keys() {
    const keys = [];
    for (const key of this.keyArray) {
      try {
        const number = Number.parseFloat(key);
        keys.push(number);
      } catch (err) {
        keys.push(key);
      }
    }
    return keys;
  }
  static stringPath(array) {
    return array.join(".");
  }
  static toStringArray(array) {
    return array.map((value) => value.toString());
  }
};
RenderableConfigItem._class = "RenderableConfigItem";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? A.getGloballyUniqueID() })
], RenderableConfigItem.prototype, "_id", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], RenderableConfigItem.prototype, "size", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => [String])
], RenderableConfigItem.prototype, "keyArray", 2);
RenderableConfigItem = __decorateClass([
  Entity()
], RenderableConfigItem);
var RenderableConfigItemString = class extends RenderableConfigItem {
};
RenderableConfigItemString._class = "RenderableConfigItemString";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String)
], RenderableConfigItemString.prototype, "value", 2);
RenderableConfigItemString = __decorateClass([
  Entity()
], RenderableConfigItemString);
var RenderableConfigItemInt = class extends RenderableConfigItem {
};
RenderableConfigItemInt._class = "RenderableConfigItemInt";
__decorateClass([
  validate(nonOptional()),
  Field((type) => Int)
], RenderableConfigItemInt.prototype, "value", 2);
RenderableConfigItemInt = __decorateClass([
  Entity()
], RenderableConfigItemInt);
var RenderableConfigItemBoolean = class extends RenderableConfigItem {
};
RenderableConfigItemBoolean._class = "RenderableConfigItemBoolean";
__decorateClass([
  validate(nonOptional({ allowFalsy: true })),
  Field((type) => Boolean)
], RenderableConfigItemBoolean.prototype, "value", 2);
RenderableConfigItemBoolean = __decorateClass([
  Entity()
], RenderableConfigItemBoolean);
export {
  RenderableConfig,
  RenderableConfigItem,
  RenderableConfigItemBoolean,
  RenderableConfigItemInt,
  RenderableConfigItemString
};
